import React, { Component } from 'react';
import Logo from '../Components/Logo.js';
import ShareRoom from './ShareRoom.js';
import './RoomHeader.css';

export default class extends Component {
  render() {
    return (
      <header>
        <Logo />
        <div className="room-controls">
          <ShareRoom roomName={this.props.roomName}/>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Room/RoomHeader.js